import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';

import ModalBody from '../../atoms/ModalBody';
import ModalFotterYesNoButtonComponent from '../../molecules/ModalFotterYesNoButtonComponent';

class DeleteAlertModal extends React.Component {
  static get propTypes() {
    return {
      targetId: PropTypes.string,
      children: PropTypes.string,
      show: PropTypes.bool,
      onClickYes: PropTypes.func,
      onClickNo: PropTypes.func,
    };
  }

  render() {
    return (
      <Modal show={this.props.show} size="lg">
        <ModalBody>
          <p className="text-center">
            選択されたイベントにはすでに申込会員が存在するものが含まれています。
            <br></br>
            本当に削除してよろしいですか？
          </p>
        </ModalBody>
        <ModalFotterYesNoButtonComponent
          onYesClick={this.props.onClickYes}
          onNoClick={this.props.onClickNo}
        />
      </Modal>
    );
  }
}

export default DeleteAlertModal;
